import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-203" data-mp="nxxdgaykoueu">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold-500/30 bg-void-950/95 shadow-[0_-10px_40px_rgba(34,227,127,0.12)] backdrop-blur" data-id="element-204" data-mp="juhkbolppc6w">
          <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-5 py-3.5" data-id="element-205" data-mp="297kzttkimz3w">
            <div className="min-w-0" data-id="element-206" data-mp="2491cboq9xf9f">
              <p className="truncate font-display text-lg font-light text-bone-50" data-id="element-207" data-mp="3ieqtlcq9v9rp">
                ¿Estás listo para jugar?
              </p>
              <p className="text-xs text-bone-500" data-id="element-208" data-mp="3mehhn8oezbsj">
                <span className="line-through" data-id="element-209" data-mp="38hma5knt9sel">$44.900 CLP</span>{' '}
                <span className="text-gold-400" data-id="element-210" data-mp="3dfw5pwdg6v0q">$9.990 CLP</span> · Acceso inmediato
              </p>
            </div>
            <CTAButton label="Obtener eBook" className="shrink-0 px-6 py-3" data-id="element-211" data-mp="4zkjzveh7uzm" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}